<template>
  <div>
    <div class="common__loading__2ISqR" style="user-select: none; display: none">
      <div class="common__loadingWarp__jRby5"><img src="/static/image/loading-01298b545f5c991b77dcfde358b313f2.png" alt="loadingGif" style="width: 96px; height: 96px" /></div>
    </div>
    <div class="login__login_container__19JVq">
      <img src="/static/image/bg.aeffce071a77b9f3cadbb3e35832d14b.jpg" width="100%" style="width: 100%; height: 100vh" />
      <video id="login_video" autoplay preload loop class="login__video__3vENQ"><source src="/static/image/video.mp4" type="video/mp4" /></video>
      <div class="login__login_box__2nAFl">
        <div class="login__contentBox__2Z4Z7 login__sp__3RBFD">
          <div data-analytics="button" data-label="登录-logo" class="login__logo__1NulW" style="margin-bottom: 23px">
            <a><img style="    margin: 0 auto;" src="/static/image/login_logo.0c8565183609c43ac8bf5dcbac9c6ce3.svg" width="310px" height="98px" /></a>
          </div>
          <div class="styles__sponsor__iVADu" style="margin-bottom: 28px">
            <div class="styles__title__2vzEr">赞助伙伴</div>
            <div class="styles__sponsorBox__ePs6n"><img src="/static/image/zz_ob.dd3909f497e7ad7b077fddd9c608420a.png" height="44px" /></div>
          </div>
          <div>
            <ul class="register__login_input__2JBiQ">
              <li class="register__row__2AFZD">
                <div class="register__userWrap__2EOis"><i class="register__icon__2fHin register__user__3ejK8"></i> <input v-model="loginInfo.name" type="text" placeholder="用户名" name="name" id="login_form_username" maxlength="32" value="" /></div>
              </li>
              <li class="register__row__2AFZD">
                <div class="register__userWrap__2EOis">
                  <div style="position: relative; display: inherit; width: 100%">
                    <i class="register__icon__D7BhQ register__password__2Yj9_"></i> <input v-model="loginInfo.password" :type="passShow ? 'password' : 'text'" placeholder="密码" name="password" maxlength="32" autocomplete="off" value="" />
                    <div style="position: absolute; top: 13px; right: 12px; width: 16px; height: 16px; cursor: pointer" @click="changPassShow">
                      <img v-if="passShow" src="/static/image/eye_close.0a2c8f5a5502b3cd6835e8c19be3bfbd.png" width="16px" height="16px" style="display: block" />
                      <img v-else src="/static/image/eye_see.cfa834943719d71c121de1ebd3440954.png" width="16px" height="16px" style="display: block" />
                    </div>
                  </div>
                </div>
              </li>
              <li class="register__row__2AFZD">
                <div class="register__userWrap__2EOis">
                  <i class="register__icon__D7BhQ register__password__2Yj9_"></i> <input v-model="loginInfo.code" type="text" placeholder="验证码" maxlength="6" style="padding-right: 0" />
                  <img style="cursor: pointer; height: 37px; padding-top: 2px; padding-right: 8px" :src="`/static/image/yzm/${imgLis[index]}.png`" @click="changIndex" alt="" />
                </div>
              </li>
              <li class="login__forgetpasswordButton__3Le8o">
                <div class="login__checkBox__3UDyY">
                  <i class="login__actived__3GArM"></i>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                    <g fill="none" fill-rule="evenodd">
                      <g>
                        <g transform="translate(-35 -35) translate(35 35)">
                          <rect width="15" height="15" fill="#63B8FC" rx="3"></rect>
                          <path fill="#FFF" fill-rule="nonzero" d="M11.418 3.028L12.582 3.972 6.449 11.535 2.549 8.595 3.451 7.397 6.195 9.465z"></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <a>记住密码</a>
                </div>
                <a @click="$parent.openKefu" target="_blank">忘记密码?</a>
              </li>
              <li><button type="button" class="register__submit__3siWx" @click="login" style="opacity: 1">登录</button></li>
              <div class="login__linkGroup__3kpQw"><span data-label="登 录-注册账号" @click="$parent.goNav('/register')">注册新账号</span><span @click="$parent.goNav('/')" data-label="登 录-先去逛逛">先去逛逛</span></div>
            </ul>
          </div>
          <div class="login__service__1lRgp">
            <a @click="$parent.openKefu" target="_blank"
              ><div class="register__service__etg7Y"><img src="/static/image/icon-online-service.6b73e5a37af863724b3a063314163f8a.svg" width="29px" class="register__serviceIcon__2PLa8" /><span style="cursor: pointer">联系客服</span></div></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'login',
  data() {
    return {
      loginInfo: {},
      passShow: true,
      imgLis: ['2PYL', '6AQ5', '8PHD', '21I7', '69HM', 'ACWA', 'DUZ7', 'IY98', 'K647', 'M52T', 'NY52', 'NZFA', 'SN76', 'SP4D', 'VAEO', 'YFQM', 'ZZU5', '7GQT', 'LFW3', 'NU2T', 'UAE3'],

      index: 0,
    };
  },
  created() {
    let that = this;
    that.changIndex();
  },
  methods: {
    changIndex() {
      this.index = parseInt(20 * Math.random());
    },
    changPassShow() {
      this.passShow = !this.passShow;
    },
    login() {
      let that = this;
      let info = that.loginInfo;
      if (!info.name || !info.password) {
        that.$parent.showTost(0, '请输入您的账号和密码！');
        return;
      }
      // let code = that.loginInfo.code;
      // if (!code) {
      //   that.$parent.showTost(0, '请输入验证码！');
      //
      //   return;
      // }
      // if (code.toUpperCase() != that.imgLis[that.index]) {
      //   that.$parent.showTost(0, '验证码错误！');
      //   that.loginInfo.code = null;
      //   that.changIndex();
      //   return;
      // }
      that.$parent.showLoading();
      that.$apiFun.login(info).then(res => {
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
          that.registerInfo.code = null;
          that.changIndex();
          that.$parent.hideLoading();
        }
        if (res.code === 200) {
          sessionStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.getUserInfo();
          that.$parent.openDaoTime();
        }
      });
    },
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
          that.$router.push({ path: '/' });
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../static/css/registermember.css';
</style>



// WEBPACK FOOTER //
// src/components/login.vue